export default __webpack_public_path__ + "static/poster-6deaa2a633d967aaf9cae97cfe296e0e.png";